import { render } from "./LabeledRichTextReports.vue?vue&type=template&id=891e000e"
import script from "./LabeledRichTextReports.vue?vue&type=script&lang=js"
export * from "./LabeledRichTextReports.vue?vue&type=script&lang=js"

import "./LabeledRichTextReports.vue?vue&type=style&index=0&id=891e000e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__